import { render, staticRenderFns } from "./PostShow.vue?vue&type=template&id=7f41a8e1"
import script from "./PostShow.vue?vue&type=script&lang=js"
export * from "./PostShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f41a8e1')) {
      api.createRecord('7f41a8e1', component.options)
    } else {
      api.reload('7f41a8e1', component.options)
    }
    module.hot.accept("./PostShow.vue?vue&type=template&id=7f41a8e1", function () {
      api.rerender('7f41a8e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/PostShow.vue"
export default component.exports